// Article Forms Constants

export const MAX_IMAGES_PER_SECTION = 5;
export const MAX_SECTIONS = 5;
export const MAX_DESCRIPTION_LENGTH = 1000; // Maximum characters for carousel description

// Article Forms Suggestions

export const TAG_SUGGESTIONS = {
    // Business Services Categories
    business: [
        'Business Consulting', 'Management Consulting',
        'Financial Consulting', 'Legal Consulting',
        'HR Consulting', 'IT Consulting',
        'Marketing Consulting', 'Business Strategy',
        'Business Development', 'Market Research',
        'Business Planning', 'Business Analysis',
        'Business Process', 'Business Intelligence',
        'Business Optimization', 'Business Transformation',
        'Business Coaching', 'Business Mentorship',
        'Business Growth', 'Business Scaling',
        'Business Expansion', 'Business Turnaround'
    ],

    // Professional Services
    professional: [
        'Accounting Services', 'Tax Services',
        'Legal Services', 'Law Firm',
        'Financial Services', 'Investment Services',
        'Insurance Services', 'Real Estate Services',
        'Architectural Services', 'Engineering Services',
        'Design Services', 'Creative Services',
        'Translation Services', 'Language Services',
        'Security Services', 'Risk Management',
        'Audit Services', 'Compliance Services'
    ],

    // Technology Services
    technology: [
        'Web Development', 'App Development',
        'Software Development', 'IT Services',
        'Cloud Services', 'Cybersecurity Services',
        'Data Services', 'Analytics Services',
        'AI Services', 'Machine Learning Services',
        'Digital Transformation', 'Tech Consulting',
        'Tech Support', 'Tech Maintenance',
        'Tech Training', 'Tech Integration'
    ],

    // Marketing Services
    marketing: [
        'Digital Marketing', 'Social Media Marketing',
        'Content Marketing', 'SEO Services',
        'PPC Services', 'Email Marketing',
        'Brand Strategy', 'Marketing Strategy',
        'Marketing Analytics', 'Marketing Automation',
        'Influencer Marketing', 'Affiliate Marketing',
        'Event Marketing', 'Trade Shows',
        'PR Services', 'Media Relations'
    ],

    // Customer Services
    customer: [
        'Customer Support', 'Customer Service',
        'Customer Experience', 'Customer Success',
        'Customer Retention', 'Customer Acquisition',
        'Customer Analytics', 'Customer Feedback',
        'Customer Journey', 'Customer Loyalty',
        'Customer Training', 'Customer Onboarding',
        'Customer Portal', 'Customer Support System'
    ],

    // Operations Services
    operations: [
        'Supply Chain Management', 'Logistics Services',
        'Warehouse Management', 'Inventory Management',
        'Fleet Management', 'Asset Management',
        'Facility Management', 'Office Management',
        'Project Management', 'Process Management',
        'Quality Management', 'Risk Management',
        'Compliance Management', 'Document Management',
        'Workflow Management', 'Task Management'
    ]
};

// Convert suggestions to the format expected by Mention component
export const FORMATTED_TAG_SUGGESTIONS = Object.entries(TAG_SUGGESTIONS).flatMap(([category, tags]) =>
    tags.map(tag => ({
        label: tag,
        nickname: tag,
        category
    }))
);
